export function getChildPaddings(style) {
    var _a = style.padding, padding = _a === void 0 ? 'none' : _a, _b = style.paddingHorizontal, paddingHorizontal = _b === void 0 ? padding : _b, _c = style.paddingVertical, paddingVertical = _c === void 0 ? padding : _c, _d = style.paddingTop, childPaddingTop = _d === void 0 ? paddingVertical : _d, _e = style.paddingRight, childPaddingRight = _e === void 0 ? paddingHorizontal : _e, _f = style.paddingBottom, childPaddingBottom = _f === void 0 ? paddingVertical : _f, _g = style.paddingLeft, childPaddingLeft = _g === void 0 ? paddingHorizontal : _g;
    return {
        childPaddingTop: childPaddingTop,
        childPaddingRight: childPaddingRight,
        childPaddingBottom: childPaddingBottom,
        childPaddingLeft: childPaddingLeft,
    };
}
